var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.545,
    height: 17.96,
    viewBox: "0 0 16.545 17.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile_outline",
    "data-name": "Profile outline",
    transform: "translate(0.752 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M175.541,52.26c-.174,2.346-1.953,4.26-3.905,4.26s-3.734-1.913-3.905-4.26a3.92,3.92,0,1,1,7.81,0Z",
    transform: "translate(-164.115 -48)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M71.518,304a7.361,7.361,0,0,0-7.506,6.151c-.077.485.165.95.613.95H78.411c.448,0,.69-.465.613-.95A7.362,7.362,0,0,0,71.518,304Z",
    transform: "translate(-63.998 -294.64)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.2143db44d7dd6850dd996dc38553d9c6.svg";
export { ForwardRef as ReactComponent };